<template>
    <div v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.7)">
        <el-row style="height: 40px;line-height: 40px;margin-top: 20px">
            <el-col :span="14">
                <span style="font-weight: bold;margin-right: 10px">月份</span>
<!--                <el-date-picker-->
<!--                        style="width: 150px"-->
<!--                        format="yyyy-MM"-->
<!--                        v-model="date"-->
<!--                        type="month"-->
<!--                        :clearable="false"-->
<!--                        placeholder="选择月">-->
<!--                </el-date-picker>-->
                <reportMonth :handleSelectInput="handleSelectInput"></reportMonth>
                <el-checkbox style="margin-left: 20px" v-model="checked"><span style="font-size: 15px;font-weight: bold">只显示目标客户</span></el-checkbox>
            </el-col>
            <el-col :span="10">
                <div style="float: right">
                    <span style="font-size: 16px;font-weight: bold;margin-right: 10px;">辖区</span>
                    <popedom :handleSelectInput="handleSelectInputClick" :shelfData="shelfData"></popedom>
                </div>
            </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
            <el-col>
                <el-button size="small" style="background: #4EC880;border:none;color: #fff" @click.stop="onQuery">查询</el-button>
                <el-button size="small" style="background: #D0021B;border:none;color: #fff" @click.stop="ResetClick">重置</el-button>
                <el-button size="small" style="float: right;background: #4A90E2;border:none;color: #fff" icon="el-icon-upload2" @click.stop="handleExportDataBy_i">
                    导出数据
                </el-button>
            </el-col>
            <el-col style="border-bottom: 2px dotted rgb(231, 234, 236);margin-top: 20px"></el-col>
        </el-row>
        <div>
            <div style="margin-top: 15px;">
                <span style="font-weight: bold;font-size: 22px">{{yearsDate}}</span>
                <span style="color:#ff9901">目标客户{{data.accounts}}家</span>
                <span style="color:#6fa7e8">辖区内共{{data.storeNum}}家门店</span>
            </div>
            <div style="margin-top: 20px;display: flex;justify-content: flex-start">
                <el-col span="11" >
                    <div id="room" style="height: 320px;width: 100%;">

                    </div>
                </el-col>
                <el-col span="1">
                    <div style="height: 100px;width: 2px;background: #9fa5ac;margin: 50px 20px"></div>
                </el-col>
                <el-col span="11">
                    <div id="grade" style="height: 320px;width: 100%;">

                    </div>
                </el-col>
            </div>
            <el-table
                    :data="tableData"
                    style="width: 100%;margin-top: 20px"
            >
                <el-table-column
                        width="100"
                        v-if="isManager"
                        prop="territory_name"
                        label="所属辖区"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="store_name"
                        label="门店名称"
                         sortable>
                </el-table-column>
                <el-table-column
                        prop="productnum"
                        label="涉及产品数"
                        width="120" sortable>
                </el-table-column>
                <el-table-column
                        prop="type"
                        label="类型"
                        width="120" sortable>
                </el-table-column>
                <el-table-column
                        prop="grade"
                        label="级别"
                        width="80" sortable>
                </el-table-column>
                <el-table-column
                        label="客户等级"
                        width="120"
                        sortable>
                    <template slot-scope="scope">
                        <span>{{scope.row.segment_id ? scope.row.segment_id : '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        width="120"
                        prop="clerk"
                        label="店员人数" sortable>
                </el-table-column>
                <el-table-column
                        width="120"
                        label="目标客户"
                        sortable>
                    <template slot-scope="scope">
                        <span>{{scope.row.reference_id ? '是' : '否' }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div style="margin-bottom: 10px">
                <pagination :page="page" @changePage="changePageClick"></pagination>
            </div>
        </div>
    </div>
</template>

<script>

    import http from '../../../../../APIService/http'
    import moment from 'moment'
    import popedom from "../../popedom"
    import pagination from '../../../../../components/pagination'
    import reportMonth from '../../reportMonth'
    export default {
        data() {
            return {
                date:'',
                checked:false,
                roomChart:'',
                gradeChart:'',
                page: {
                    current: 1,
                    size: 5,
                    total: 0
                },
                tableData:[],
                data:{},
                isManager:this.$store.getters.getUser.role !== 'staff',
                yearsDate:'',
                loading:false
            };
        },
        components:{
            popedom,
            pagination,
            reportMonth
        },

        mounted() {
            this.getData()
            this.getTablesList()
            window.onresize = () => {
                this.roomChart.resize()
                this.gradeChart.resize()
            }
        },
        created() {
            if(this.GLOBAL.date){
                this.yearsDate = moment(this.GLOBAL.date).format('YYYY年M月')
            }else{
                this.yearsDate = moment().format('YYYY年M月')
            }
        },
        methods:{
            shelfData(){
                this.getData()
                this.getTablesList()
            },
            handleSelectInputClick(i){
                this.getData()
                this.getTablesList()
            },
            handleSelectInput(j){
                this.date = j
            },
            // 改变页码信息
            changePageClick(page, size) {
                if (page) {
                    this.page.current = page
                }
                if (size) {
                    this.page.size = size
                }

                this.getTablesList('loading')
            },
            async getData(){
                // let loading = this.$loading({
                //     lock: true,
                //     text: '拼命加载中',
                //     spinner: 'el-icon-loading',
                //     background: 'rgba(0, 0, 0, 0.7)'
                // });
                this.loading = true


                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        user_id : user.user_id,
                        tenant_id : user.tenant_id,
                        month : this.GLOBAL.date,
                        territory_id : this.GLOBAL.territory_id,
                        isAccountShow:this.checked
                    }
                    await http.post('/wapi/v1/getTerritoryByCustomer_s',data).then(res=>{
                        if (res.success){
                            this.data = res.data

                            if (this.data.departmentArray.length > 0 ){
                                for (let i = 0;i<this.data.departmentArray.length;i++){
                                    this.data.departmentArray[i].name = this.data.departmentArray[i].value1
                                    this.data.departmentArray[i].value = this.data.departmentArray[i].count
                                }
                            }
                            if (this.data.segmentArray.length > 0 ){
                                for (let i = 0;i<this.data.segmentArray.length;i++){
                                    this.data.segmentArray[i].name = this.data.segmentArray[i].segment_name +''
                                    this.data.segmentArray[i].value = this.data.segmentArray[i].accounts
                                }
                            }


                            //渲染饼状图
                            this.init()
                            // loading.close()
                        }else {
                            // loading.close()
                            this.loading = false
                        }
                    })
                    // loading.close()
                }catch (e) {
                    // loading.close()
                    this.loading = false
                }
            },
            async getTablesList(type){

                // let loading
                // if (type === 'loading') {
                //     loading = this.$loading({
                //         lock: true,
                //         text: '拼命加载中',
                //         spinner: 'el-icon-loading',
                //         background: 'rgba(0, 0, 0, 0.7)'
                //     });
                // }else {
                //
                // }
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        limit: this.page.size,
                        offset: this.page.current - 1,
                        user_id : user.user_id,
                        tenant_id : user.tenant_id,
                        month : this.GLOBAL.date,
                        territory_id : this.GLOBAL.territory_id,
                        isAccountShow:this.checked
                    }
                    await http.post('/wapi/v1/getTerritoryByTables_s',data).then(res=>{
                        if (res.success){
                            if (res.data.length > 0){
                                this.page.total = parseInt(res.data[0].totalitemcount)
                            }else {
                                this.page.total = 0
                            }
                            this.tableData = res.data
                            // loading.close()
                            this.loading = false
                        }else {
                            // loading.close()
                            this.loading = false
                        }
                    })
                    // loading.close()
                }catch (e) {
                    // loading.close()
                    this.loading = false
                }
            } ,
            init(){
                this.roomChart=this.$echarts.init(document.getElementById('room'));
                this.gradeChart=this.$echarts.init(document.getElementById('grade'));
                this.roomChart.setOption({
                    title : {
                        text: '类型分布',
                        x:'center',
                        y: 'bottom',
                        textStyle:{
                            color:"#6fa7e8"
                        }
                    },
                    series : [
                        {
                            type: 'pie',    // 设置图表类型为饼图
                            radius: '50%',
                            label : {
                                normal : {
                                    formatter: '{w|{b} {d}%}\n{n|({c}家)}',
                                    rich: {
                                        w:{
                                            fontSize : 12,
                                            color:'#ff9901'
                                        },
                                        n:{
                                            color: '#999ba1',
                                            align: 'center',
                                            fontSize: 12,
                                        }

                                    }
                                }
                            },
                            data:this.data.departmentArray,
                            center:["50%","40%"]
                        }
                    ],
                    color:["#50e3c2","#63a9fa","#d16366","#fecfa3","#F996FE","#67C23A","#E6A23C","#F56C6C","#909399","#DCDFE6"]
                })
                this.gradeChart.setOption({
                    title : {
                        text: '级别分布',
                        x:'center',
                        y: 'bottom',
                        textStyle:{
                            color:"#6fa7e8"
                        }
                    },
                    series : [
                        {
                            name: '访问来源',
                            type: 'pie',    // 设置图表类型为饼图
                            radius: '50%',
                            label : {
                                normal : {
                                    formatter: '{w|{b} {d}%}\n{n|({c}家)}',
                                    rich: {
                                        w:{
                                            fontSize : 15,
                                            color:'#ff9901'
                                        },
                                        n:{
                                            color: '#999ba1',
                                            align: 'center',
                                            fontSize: 15,
                                        }

                                    }
                                }
                            },
                            data:this.data.segmentArray,
                            center:["50%","40%"]
                        }
                    ],
                    color:["#50e3c2","#63a9fa","#d16366","#fecfa3","#F996FE","#67C23A","#E6A23C","#F56C6C","#909399","#DCDFE6"]
                })

            },
            onQuery(){
                this.GLOBAL.date = this.date
                this.yearsDate = moment(this.GLOBAL.date).format('YYYY年M月')
                this.page= {
                    current: 1,
                    size: 5,
                    total: 0
                }
                this.getData()
                this.getTablesList()
            },
            ResetClick(){
                this.date = new Date()
                this.checked = false
                this.page= {
                    current: 1,
                    size: 5,
                    total: 0
                }
                this.getData()
                this.getTablesList()
            },
            async handleExportDataBy_i() {
                try {
                    let loading = this.$loading({
                        lock: true,
                        text: '拼命加载中',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });

                    //工时统计表
                    import('@/vendor/Export2Excel').then(excel => {
                        let tHeader = ['门店名称', '涉及产品数', '类型', '级别', '客户等级', '店员人数', '是否目标客户']
                        let filterVal = ['store_name', 'productnum' , 'type' , 'grade'
                            ,'segment_id','clerk','reference_id']
                        if (this.isManager){
                            tHeader.unshift('所属辖区')
                            filterVal.unshift('territory_name')
                        }

                        let list = []
                        let user = this.$store.getters.getUser
                        let obj = {
                            limit: 999999999999,
                            offset: 0,
                            user_id : user.user_id,
                            tenant_id : user.tenant_id,
                            month : this.date,
                            territory_id : this.GLOBAL.territory_id,
                            isAccountShow:this.checked
                        }
                        try {
                            http.post('/wapi/v1/getTerritoryByTables_s',obj).then(res=>{

                                if (res.success){
                                    list = res.data
                                    loading.close()
                                    list.forEach((item)=>{
                                        item.reference_id = item.reference_id ? '是' : '否'
                                    })
                                    const data = this.formatJson(filterVal, list)

                                    excel.export_json_to_excel({
                                        header: tHeader,
                                        data,
                                        filename: '辖区概览(零售终端)',
                                        autoWidth: this.autoWidth
                                    })
                                }else {
                                    loading.close()
                                }
                            })
                        }catch (e) {
                            loading.close()
                        }
                        loading.close()
                    })



                } catch (err) {

                    this.error()
                }
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
        }
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/statement/components/overview/components/retailOutlet.vue